import type { SxProps } from '@mui/system';

import { useTheme } from '@mui/system';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

type Props = {
  sx?: SxProps;
  label: string | undefined;
};

function UserAvatar({ sx, label }: Props) {
  const theme = useTheme();

  return (
    <Avatar
      alt="User Avatar"
      sx={{ bgcolor: 'background.paper', width: 32, height: 32, ...sx }}
      data-testid="user-avatar"
      variant="circular"
    >
      <Typography variant="subtitle2" color={theme.palette.grey[600]}>
        {label}
      </Typography>
    </Avatar>
  );
}

export default UserAvatar;
